import { useState } from 'react';

import { useTranslation } from 'react-i18next';

import { Popup, UiButton } from '@shared/ui';

import cls from './DeleteProfileSettings.module.css';
import { useDeleteProfile } from '../../model/useDeleteProfile';

export const DeleteProfileSettings = () => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const { deleteProfile, isPending } = useDeleteProfile();

    return (
        <>
            <UiButton
                type="button"
                className={cls.deleteButton}
                btnColor="danger"
                btnText={t('profile.page.settings.deleteAccount')}
                onClick={() => setIsOpen(true)}
            />
            <Popup
                isOpen={isOpen}
                type="delete"
                contentText={t('profile.page.settings.deleteAccount.confirmText')}
                deleteButtonText={t('profile.page.settings.deleteAccount')}
                cancelButtonText={t('button.cancel.text')}
                btnActionCb={() => deleteProfile()}
                isPending={isPending}
                onHidePopup={() => setIsOpen(false)}
            />
        </>
    );
};
